export default function getUserDataUrl({ userName }) {
  return `/user/${userName}/`;
}
